export default __webpack_public_path__ + "static/media/sap.3b9ee861.svg";